export default "__VITE_ASSET__65c5c42f__"